import React, { memo } from "react";
import Title from "../../../components/Title";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import AboutUsCard from "../../../components/AboutUsCard";
import { useSelector } from "react-redux";
import DOMPurify from "dompurify";

const AboutUsSection = memo(({ servicesSectionData }) => {
  const lng = useSelector((state) => state.lang.value);
  const { t } = useTranslation();

  if (!servicesSectionData || !servicesSectionData.records || servicesSectionData.records.length === 0) {
    return null; // nothing to render yet
  }

  const records = servicesSectionData.records;
  const firstRecord = records[0] || {};
  const secondRecord = records[1] || {};
  const restServices = records.slice(2);

  return (
    <div className=" container mx-auto">
      <div className="max-w-screen-xl mt-5">
        <div className="flex items-center justify-between mb-[35px]">
          <Title
            title={
              lng === "ar"
                ? servicesSectionData.section_name
                : servicesSectionData.section_name_en
            }
          />
          <Link
            to={"/our-services"}
            className="text-viewAll w-[112px] sm:w-auto underline text-purple"
          >
            {t("View all")}
          </Link>
        </div>
        <p className="mb-12 text-center sm:text-start text-lg">
          {t("AboutParagraph")}
        </p>

        {/* Responsive Cards Layout */}
        <div className="flex flex-col gap-[20px]">
          <div className="flex gap-[20px] flex-wrap sm:flex-nowrap">
            <AboutUsCard
              titleAr={firstRecord.title_ar}
              titleEn={firstRecord.title_en}
              paragraphAr={DOMPurify.sanitize(firstRecord.description_ar)}
              paragraphEn={DOMPurify.sanitize(firstRecord.description_en)}
              icon={firstRecord.icon_url}
            />

            <AboutUsCard
              titleAr={secondRecord.title_ar}
              titleEn={secondRecord.title_en}
              paragraphAr={DOMPurify.sanitize(secondRecord.description_ar)}
              paragraphEn={DOMPurify.sanitize(secondRecord.description_en)}
              icon={secondRecord.icon_url}
            />
          </div>
          <div className="flex gap-[20px] flex-wrap md:flex-nowrap">
            {restServices.map((service) => (
              <AboutUsCard
                key={service.id}
                titleAr={service.title_ar}
                titleEn={service.title_en}
                paragraphAr={DOMPurify.sanitize(service.description_ar)}
                paragraphEn={DOMPurify.sanitize(service.description_en)}
                icon={service.icon_url}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
});

export default AboutUsSection;
